export enum AppName {

  Mobile = "Mobile",
  Master = "Master",
  BusinessSuite = "BusinessSuite",
  ChromeCFormPlugin = "ChromeCFormPlugin",
  WebGateway = "WebGateway"

}
